import React from 'react';
import {
  humanReadableFormula,
  buildDependencyMaps,
  FINANCIAL_EFFECTS,
  INCLUDE_IN_GROUPS,
  labelForPreviousBehaviour,
} from '../adapters';

const RelationshipSummaryCard = ({ field, fields }) => {
  const cfg = field.metadata?.businessConfig || {};
  const { usedBy } = buildDependencyMaps(fields);
  const used = usedBy[field.fieldCode] || [];
  const labelOf = (code) => (fields || []).find((f) => f.fieldCode === code)?.fieldLabel || code;
  const effect = FINANCIAL_EFFECTS.find((o) => o.value === cfg.financialEffect)?.label || '—';
  const include = INCLUDE_IN_GROUPS.find((o) => o.value === cfg.includeInGroup)?.label || 'None';
  const prevLabel = labelForPreviousBehaviour(cfg.previousBehaviour || 'SAME_FIELD');

  return (
    <div className="ra-tpl-summary-card">
      <strong>{field.fieldLabel || field.fieldCode}</strong>
      <div><span>Calculated as</span><p>{humanReadableFormula(field, fields)}</p></div>
      <div className="ra-tpl-summary-grid">
        <div><span>Effect</span><p>{effect}</p></div>
        <div><span>Included in</span><p>{include}</p></div>
        <div><span>RA-2+ Previous column</span><p>{prevLabel}</p></div>
        <div><span>Used by</span><p>{used.length ? used.map(labelOf).join(', ') : '—'}</p></div>
      </div>
      <div className="ra-tpl-summary-ra2">
        <span>Dependency chain</span>
        <p>
          RA-2 ← RA-1 · RA-3 ← RA-2 · RA-4 ← RA-3. Previous column on each new bill reads this field
          {(cfg.previousBehaviour || 'SAME_FIELD') === 'OTHER_FIELD' && cfg.previousFieldCode
            ? ` (via ${labelOf(cfg.previousFieldCode)})`
            : ''}
          {' '}from the immediate previous RA only. Same template format for all RA numbers.
        </p>
      </div>
    </div>
  );
};

export default RelationshipSummaryCard;
